import type { ConstValues } from '@openx/types/helpers.ts';
import type { AudienceListType, GroupLike, IndexedGroupFieldName } from '../../types.ts';

export const drawerType = {
  SEGMENTS: 'segments',
  LOOKALIKE: 'lookalike',
} as const;

export type DrawerTypeValue = ConstValues<typeof drawerType>;

export type DrawerState =
  | {
      isOpen: true;
      type: DrawerTypeValue;
      title: string;
      marketContext?: {
        region: string | null;
        countries: string[];
      };
      fieldPath: IndexedGroupFieldName;
      updater: (value: GroupLike) => void;
      listType: AudienceListType;
      onShrinkSection: () => void;
      onExpandSection: () => void;
    }
  | { isOpen: false };
